import { render, staticRenderFns } from "./ReservationDataCard.vue?vue&type=template&id=54189a5c&scoped=true&"
import script from "./ReservationDataCard.vue?vue&type=script&lang=js&"
export * from "./ReservationDataCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDataCard.vue?vue&type=style&index=0&id=54189a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54189a5c",
  null
  
)

export default component.exports